import { BackendFormResponse, retrieveEmailQuotApi } from '../util/api';

export async function getEmailPlans(quoteId: string): Promise<BackendFormResponse> {
    // Create URL-encoded form data
    const formData = new URLSearchParams();
    formData.append('quoteId', quoteId);

    const res = await fetch(`${retrieveEmailQuotApi}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formData.toString(), // Pass the URL-encoded string as the body
    });

    if (!res.ok) {
        throw new Error(`Error getting input response for quote: ${quoteId}. ${res.statusText}`);
    }

    const resData = await res.json();
    return resData;
}
